var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      class: [
        "relative",
        !_vm.last && "md:pb-20 md:pr-0 w-1/3 md:w-full flex-grow",
      ],
    },
    [
      _c("div", { staticClass: "hidden md:block" }, [
        !_vm.last
          ? _c("div", {
              class: [
                "-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full",
                _vm.completed ? "bg-fuchsia" : "bg-gray-medium",
              ],
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "relative flex space-x-4" }, [
          _c(
            "div",
            { staticClass: "h-9 flex items-center" },
            [
              _vm.completed
                ? [
                    _c(
                      "span",
                      {
                        staticClass:
                          "relative z-10 w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full",
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "w-5 h-5 text-white",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 20 20",
                              fill: "currentColor",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                "clip-rule": "evenodd",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                : _vm.active
                ? [
                    _c(
                      "span",
                      {
                        staticClass:
                          "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-fuchsia rounded-full",
                      },
                      [
                        _c("span", { staticClass: "text-fuchsia" }, [
                          _vm._v(_vm._s(_vm.number)),
                        ]),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "span",
                      {
                        staticClass:
                          "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-medium rounded-full",
                      },
                      [
                        _c("span", { staticClass: "text-gray-medium" }, [
                          _vm._v(_vm._s(_vm.number)),
                        ]),
                      ]
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "min-w-0 ml-4 flex items-center font-sans-medium text-lg",
            },
            [
              _c(
                "div",
                {
                  class: [
                    "leading-4 ",
                    _vm.active ? "text-fuchsia" : "text-gray-medium",
                  ],
                },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block md:hidden" }, [
        _c("div", { staticClass: "absolute inset-0 flex items-center" }, [
          _c("div", {
            class: [
              "h-0.5 w-full",
              _vm.completed ? "bg-fuchsia" : "bg-gray-medium",
            ],
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "relative w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full",
          },
          [
            _vm.completed
              ? [
                  _c(
                    "span",
                    {
                      staticClass:
                        "relative z-10 w-8 h-8 flex items-center justify-center bg-fuchsia rounded-full",
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "w-5 h-5 text-white",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm.active
              ? [
                  _c(
                    "span",
                    {
                      staticClass:
                        "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-fuchsia rounded-full",
                    },
                    [
                      _c("span", { staticClass: "text-fuchsia" }, [
                        _vm._v(_vm._s(_vm.number)),
                      ]),
                    ]
                  ),
                ]
              : [
                  _c(
                    "span",
                    {
                      staticClass:
                        "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-medium rounded-full group-hover:border-gray-400 group-focus:border-gray-400 transition ease-in-out duration-150",
                    },
                    [
                      _c("span", { staticClass: "text-gray-medium" }, [
                        _vm._v(_vm._s(_vm.number)),
                      ]),
                    ]
                  ),
                ],
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }